import { isValidEmail, getIntegerValuesFromString, containsSpecialCharacters, containsNumericValue } from "../helpers";
import { validateContact } from "./GlobalValidations";

export function validateUserInfo(values) {
    let errors = {}

    if (!values.firstName || (values.firstName && !values.firstName.replaceAll(" ", "")))
        errors.firstName = "First name is required"

    else if (values.firstName && containsNumericValue(values.firstName))
        errors.firstName = "Name can not contain numeric characters"

    else if (values.firstName && containsSpecialCharacters(values.firstName))
        errors.firstName = "Name can not contain special characters except space"

    else if (values.firstName && values.firstName.length < 2)
        errors.firstName = "Name can not be less than 2 characters"

    else if (values.firstName && values.firstName.length > 50)
        errors.firstName = "Name can not be more than 50 characters"

    else if (!values.lastName || (values.lastName && !values.lastName.replaceAll(" ", "")))
        errors.lastName = "Last name is required"

    else if (values.lastName && containsNumericValue(values.lastName))
        errors.lastName = "Name can not contain numeric characters"

    else if (values.lastName && containsSpecialCharacters(values.lastName))
        errors.lastName = "Name can not contain special characters except space"

    else if (values.lastName && values.lastName.length < 2)
        errors.lastName = "Name can not be less than 2 characters"

    else if (values.firstName && values.lastName.length > 50)
        errors.lastName = "Name can not be more than 50 characters"

    else if (!values.email)
        errors.email = "Email can not be null"

    else if (!isValidEmail(values.email))
        errors.email = "Email is invalid"

    else if (!values.address)
        errors.address = "Address is required"

    else if (values.address && values.address.length > 50)
        errors.address = "Name can not be more than 50 characters"

    else if (validateContact(values.contactNumber, true))
        errors.contactNumber = validateContact(values.contactNumber, true)
    // else if (!values.contactNumber)
    //     errors.contactNumber = "Contact is required"

    // else if (values.contactNumber && getIntegerValuesFromString(values.contactNumber).length < 6)
    //     errors.contactNumber = "Contact can not be less than 6 digits"

    else if (!values.country)
        errors.country = "Country is required"

    else if (!values.city)
        errors.city = "City is required"

    else if (values.city && values.city.length > 50)
        errors.city = "City can not be more than 50 characters"

    // else if (values.city && containsSpecialCharacters(values.city))
    //     errors.city = "City can not contain special characters"

    else if (values.city && containsNumericValue(values.city))
        errors.city = "City can not contain numeric value"

    else if (!values.countryState)
        errors.countryState = "Country state is required"

    else if (!values.zipCode)
        errors.zipCode = "Zip code is required"

    else if (values.zipCode && values.zipCode.length > 10)
        errors.zipCode = "zip Code can not be more than 10 characters"

    return errors;
}